import React, { useEffect, useState } from "react";
import CoachScorecardTab from "./coach-scorecard";
// import "./styles.scss";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
export default function OnboardingDashboard({ params }) {
  const [selectedTab, setSelectedTab] = useState("CoachScorecard");
  const companyId = params?.id ?? "";
  const location = useLocation();
  const replaceWithTab = new URLSearchParams(location.search).get("tab");

  useEffect(() => {
    if (replaceWithTab) setSelectedTab(replaceWithTab);
  }, [replaceWithTab]);

  return (
    <div>
      {companyId === "" && (
        <header className="page-header">
          <div className="page-header-title">
            <h1>
              <span className="page-title ">Onboarding Dashboard</span>
            </h1>
          </div>
        </header>
      )}
      <div>
        <ul className="compliance-dashboard-tabs" style={{ flex: "1 1 0px" }}>
          <li
            className={selectedTab === "CoachScorecard" ? "is-active" : ""}
            onClick={() => setSelectedTab("CoachScorecard")}
          >
            Coach Scorecard
          </li>
        </ul>
      </div>
      <div className="content">
        {selectedTab === "CoachScorecard" && (
          <CoachScorecardTab companyId={companyId} />
        )}
      </div>
    </div>
  );
}

OnboardingDashboard.propTypes = {
  params: PropTypes.object
};
